import React from 'react';
import { Times } from 'styled-icons/fa-solid/Times';
import { LayoutBox, Card, CardProps, TextBox, Button } from 'src/kit';
import { renderCustomError } from './customErrors';

export type ErrorMessagesProps = CardProps & {
  onClose: () => void;
  title?: string;
  errors?: string[];
};

export const ErrorMessages = ({ onClose, title, errors, ...styledProps }: ErrorMessagesProps) => (
  <>
    {Boolean(errors?.length) && (
      <Card mb={30} p={15} bg="#f2dede" borderColor="#ebccd1" {...styledProps}>
        <Button onClick={onClose} ml="auto" width={14} height={14}>
          <Times size={14} css="color: #de8a8c; cursor: pointer; :hover { color: #a94442; }" />
        </Button>
        <TextBox as="h4" mt={0} mb={10} color="#a94442" fontSize={18} fontWeight="bold">
          {title || `${errors.length} error prohibited this form from being saved`}
        </TextBox>
        <LayoutBox as="ul" pl={15} rowGap={5}>
          {errors.map(error => renderCustomError(error))}
        </LayoutBox>
      </Card>
    )}
  </>
);
